import { Navigate, useParams } from '@tanstack/react-router';
import LoadingScreen from 'components/LoadingScreen';
import { useGetExpectedRoleIdFromParams } from 'hooks/useGetExpectedRoleIdFromParams';
import { useEffect } from 'react';
import { useAuthStore } from 'stores/authStore';

const PharmacyExpiredProductsRequestRoleSwitch = () => {
  const { pharmacy_id, id } = useParams({
    from: '/pharmacies/$pharmacy_id/expired_products_request/$id',
  });

  const currentRoleId = useAuthStore((state) => state.currentRoleId);
  const setCurrentRoleId = useAuthStore((state) => state.setCurrentRoleId);
  const expectedRoleId = useGetExpectedRoleIdFromParams('Pharmacy', pharmacy_id);
  const hasExpectedRole = currentRoleId === expectedRoleId;

  useEffect(() => {
    if (!expectedRoleId) return;

    setCurrentRoleId(expectedRoleId);
  }, [expectedRoleId, setCurrentRoleId]);

  return hasExpectedRole ? (
    <Navigate to="/pharmacy/claims/expired_products_request/$id" params={{ id }} />
  ) : (
    <LoadingScreen />
  );
};

export default PharmacyExpiredProductsRequestRoleSwitch;
